import React, { type SVGProps } from "react";
import { iconSizes, type IconProps } from "./utils/shared";
const AxeX = (props: SVGProps<SVGSVGElement> & IconProps) => (
  <svg
    width={props.size ? iconSizes[props.size] : iconSizes["s"]}
    height={props.size ? iconSizes[props.size] : iconSizes["s"]}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    title="AxeX"
    {...props}
  >
    <rect
      x={4}
      y={27.667}
      width={2.66667}
      height={24}
      transform="rotate(-90 4 27.667)"
      fill="#394959"
    />
    <rect
      x={4}
      y={22.666}
      width={4}
      height={2.66667}
      transform="rotate(-90 4 22.666)"
      fill="#394959"
    />
    <rect x={4} y={16} width={4} height={2.66667} transform="rotate(-90 4 16)" fill="#394959" />
    <rect
      x={4}
      y={9.33398}
      width={4}
      height={2.66667}
      transform="rotate(-90 4 9.33398)"
      fill="#394959"
    />
    <path
      d="M14.5115 10.666L15.9974 13.9716L17.5629 10.666H21.1981L18.4651 15.9993L21.3307 21.3327H17.7221L15.9974 17.9438L14.3258 21.3327H10.6641L13.5563 15.9993L10.8498 10.666H14.5115Z"
      fill="#394959"
    />
  </svg>
);
export default React.memo(AxeX);
